import axios from "axios";
import {
  MDBBreadcrumb,
  MDBBreadcrumbItem,
  MDBCard,
  MDBCardBody,
  MDBCardImage,
  MDBCardText,
  MDBCol,
  MDBContainer,
  MDBIcon,
  MDBListGroup,
  MDBListGroupItem,
  MDBProgress,
  MDBProgressBar,
  MDBRow,
} from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CompetitionCategories } from "../../Creative/Individual/AdminCategories";
const API_URL = `${process.env.REACT_APP_BACKENE_BASE_URL}/individuals`;

export default function ProfilePage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [individualData, setIndividualData] = useState({});
  const baseURL = process.env.REACT_APP_BACKENE_BASE_URL;
  useEffect(() => {
    const fetchTableData = async () => {
      try {
        const response = await axios.get(`${API_URL}/${id}`, {});
        const data = response.data.data;
        setIndividualData(data);
      } catch (error) {
      } finally {
      }
    };
    fetchTableData();
  }, []);
  const getCategory = () => {
    const cat = CompetitionCategories.filter(
      (cat) => cat.value == individualData.category
    )[0]?.label;
    return cat;
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };
  return (
    <section style={{ backgroundColor: "#eee", overflowY: "auto" }}>
      <MDBContainer className="pb-5">
        <MDBRow style={{ width: "100px" }} className="mb-4">
          <button
            type="button" // Use "button" to prevent form submission if this button is not meant to submit the form
            className="btn btn-primary"
            onClick={() => {
              navigate(-1);
            }}
          >
            Back
          </button>
        </MDBRow>
        <MDBRow>
          <MDBCol>
            <MDBBreadcrumb className="bg-light rounded-3 p-3 mb-4">
              <MDBBreadcrumbItem>
                <a href='#'>Individual Profile</a>
              </MDBBreadcrumbItem>
              {/* <MDBBreadcrumbItem>
                <a href="#">User</a>
              </MDBBreadcrumbItem>
              <MDBBreadcrumbItem active>User Profile</MDBBreadcrumbItem> */}
            </MDBBreadcrumb>
          </MDBCol>
        </MDBRow>
        <MDBRow>
          <MDBCol lg="4">
            <MDBCard
              style={{ padding: "10px", height: "auto" }}
              className="mb-4 "
            >
              <div className="d-flex justify-content-center">
                <span style={{ fontWeight: "bold" }}>Individual</span>
              </div>
              <MDBCardBody className="text-center" style={{ padding: "10px" }}>
                <MDBCardImage
                  src={`${baseURL}/${individualData.photoPath?.replace(
                    /\\/g,
                    "/"
                  )}`}
                  alt="avatar"
                  style={{
                    width: "150px",
                    border: "1px solid black",
                    margin: "5px",
                    marginBottom: "20px",
                    cursor: "pointer"
                  }}
                  fluid
                  onClick={() => {
                    const photoUrl = `${baseURL}/${individualData.photoPath?.replace(
                      /\\/g,
                      "/"
                    )}`;
                    window.open(photoUrl, "_blank");
                  }}
                />
                <p className="text-muted mb-1">{individualData.name}</p>
                <p className="text-muted mb-4">{getCategory()}</p>
                <button
                  type="button" // Use "button" to prevent form submission if this button is not meant to submit the form
                  className="btn btn-primary"
                  onClick={() => {
                    const certificateUrl = `${baseURL}/${individualData.certificatePath?.replace(
                      /\\/g,
                      "/"
                    )}`;
                    window.open(certificateUrl, "_blank");
                  }}
                >
                  Show Certificate
                </button>
              </MDBCardBody>
            </MDBCard>

            {individualData.mediaPath && (
              <button
                type="button" // Use "button" to prevent form submission if this button is not meant to submit the form
                className="btn btn-primary btn-block"
                onClick={() => {
                  const mediaPath = `${baseURL}/${individualData.mediaPath?.replace(
                    /\\/g,
                    "/"
                  )}`;
                  window.open(mediaPath, "_blank");
                }}
              >
                Show Media
              </button>
            )}

            <div
              className="d-flex justify-content-center"
                style={{ fontWeight: "bold", fontSize: "24px", marginTop: "20px" }}
            >
              Total Accompanists: {individualData?.accompanists?.length}
            </div>
           
          </MDBCol>

          <MDBCol lg="8">
            <MDBCard
              className="mb-4"
              style={{ padding: "10px", height: "auto" }}
            >
              <MDBCardBody>
                <MDBRow>
                  <MDBCol sm="3">
                    <MDBCardText>Full Name</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="9">
                    <MDBCardText className="text-muted">
                      {individualData.name}
                    </MDBCardText>
                  </MDBCol>
                </MDBRow>
                <hr />
                <MDBRow>
                  <MDBCol sm="3">
                    <MDBCardText>Father Name</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="9">
                    <MDBCardText className="text-muted">
                      {individualData.fatherName}
                    </MDBCardText>
                  </MDBCol>
                </MDBRow>
                <hr />
                <MDBRow>
                  <MDBCol sm="3">
                    <MDBCardText>Date of Birth</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="9">
                    <MDBCardText className="text-muted">
                      {formatDate(individualData.dob)}
                    </MDBCardText>
                  </MDBCol>
                </MDBRow>
                <hr />
                <MDBRow>
                  <MDBCol sm="3">
                    <MDBCardText>Email</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="9">
                    <MDBCardText className="text-muted">
                      {individualData.email || "NA"}
                    </MDBCardText>
                  </MDBCol>
                </MDBRow>
                <hr />
                <MDBRow>
                  <MDBCol sm="3">
                    <MDBCardText>Phone</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="9">
                    <MDBCardText className="text-muted">
                      {individualData.mobile}
                    </MDBCardText>
                  </MDBCol>
                </MDBRow>
                <hr />
                <MDBRow>
                  <MDBCol sm="3">
                    <MDBCardText>District</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="9">
                    <MDBCardText className="text-muted">
                      {individualData.district}
                    </MDBCardText>
                  </MDBCol>
                </MDBRow>
                <hr />
                <MDBRow>
                  <MDBCol sm="3">
                    <MDBCardText>Address</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="9">
                    <MDBCardText className="text-muted">
                      {individualData.address}
                    </MDBCardText>
                  </MDBCol>
                </MDBRow>
              </MDBCardBody>
            </MDBCard>
            {individualData?.accompanists?.length ? (
              <div
                className="d-flex justify-content-center"
                style={{ fontWeight: "bold", fontSize: "24px" }}
              >
                Accompanists
              </div>
              )
              :<></>
            }
            <MDBRow>
              {individualData?.accompanists?.length ? (
                individualData.accompanists.map((accompanist) => {
                  return (
                    <MDBCard
                      md="4"
                      style={{
                        padding: "10px",
                        height: "auto",
                        width: "40%",
                      }}
                      className=" m-4"
                    >
                      <MDBCardBody
                        className="mb-4 mb-md-0"
                      >
                        <MDBCardImage
                          src={`${baseURL}/${accompanist.photoPath?.replace(
                            /\\/g,
                            "/"
                          )}`}
                          alt="avatar"
                          style={{
                            width: "150px",
                            border: "1px solid black",
                            margin: "5px",
                            marginBottom: "20px",
                            cursor: 'pointer'
                          }}
                          fluid
                          onClick={() => {
                            const photoUrl = `${baseURL}/${accompanist.photoPath?.replace(
                              /\\/g,
                              "/"
                            )}`;
                            window.open(photoUrl, "_blank");
                          }}
                        />
                        <MDBRow>
                          <MDBCol>
                            <MDBCardText>Name</MDBCardText>
                          </MDBCol>
                          <MDBCol>
                            <MDBCardText className="text-muted">
                              {accompanist.name}
                            </MDBCardText>
                          </MDBCol>
                        </MDBRow>
                        <hr />
                        <MDBRow>
                          <MDBCol>
                            <MDBCardText>DOB</MDBCardText>
                          </MDBCol>
                          <MDBCol>
                            <MDBCardText className="text-muted">
                              {formatDate(accompanist.dob)}
                            </MDBCardText>
                          </MDBCol>
                        </MDBRow>
                        <hr />
                        <MDBRow>
                          <MDBCol>
                            <MDBCardText>Mobile</MDBCardText>
                          </MDBCol>
                          <MDBCol>
                            <MDBCardText className="text-muted">
                              {accompanist.mobile}
                            </MDBCardText>
                          </MDBCol>
                        </MDBRow>
                        <hr />
                        <MDBRow>
                          <MDBCol>
                            <MDBCardText>District</MDBCardText>
                          </MDBCol>
                          <MDBCol>
                            <MDBCardText className="text-muted">
                              {accompanist.district}
                            </MDBCardText>
                          </MDBCol>
                        </MDBRow>
                        <hr />
                        <button
                          type="button" // Use "button" to prevent form submission if this button is not meant to submit the form
                          className="btn btn-primary"
                          onClick={() => {
                            const certificateUrl = `${baseURL}/${accompanist.documentPath?.replace(
                              /\\/g,
                              "/"
                            )}`;
                            window.open(certificateUrl, "_blank");
                          }}
                        >
                          Show Certificate
                        </button>
                      </MDBCardBody>
                    </MDBCard>
                  );
                })
              ) : (
                <></>
              )}
            </MDBRow>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    </section>
  );
}
